const menuButton = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-site-menu]');
const menuCloseButton = document.querySelector('[data-menu-close]');

if (menuButton && menu) {
    const setMenuOpen = (isOpen) => {
        menuButton.setAttribute('aria-expanded', String(isOpen));
        menu.toggleAttribute('data-open', isOpen);
        document.body.toggleAttribute('data-menu-open', isOpen);
    };

    menuButton.addEventListener('click', () => {
        const isOpen = menuButton.getAttribute('aria-expanded') === 'true';

        setMenuOpen(!isOpen);
    });

    menuCloseButton?.addEventListener('click', () => {
        setMenuOpen(false);
        menuButton.focus();
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            setMenuOpen(false);
            menuButton.focus();
        }
    });
}

document.querySelectorAll('[data-site-menu] a').forEach((link) => {
    link.addEventListener('click', () => {
        menuButton?.setAttribute('aria-expanded', 'false');
        menu?.removeAttribute('data-open');
        document.body.removeAttribute('data-menu-open');
    });
});

const header = document.querySelector('[data-site-header]');

if (header) {
    const syncHeader = () => header.toggleAttribute('data-scrolled', window.scrollY > 16);

    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
}

const revealElements = document.querySelectorAll('[data-reveal]');
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (revealElements.length && !prefersReducedMotion && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('has-reveal-motion');

    const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
        });
    }, {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
    });

    revealElements.forEach((element) => revealObserver.observe(element));
} else {
    revealElements.forEach((element) => element.classList.add('is-visible'));
}

const initializeLegacyWidgets = () => {
    const $ = window.jQuery;

    if (!$) {
        return;
    }

    if ($.fn.select2) {
        $('.templatingSelect2').each(function () {
            if (!$(this).data('select2')) {
                $(this).select2({ placeholder: '' });
            }
        });
    }

    if (!$.fn.slick) {
        return;
    }

    const sliders = [
        ['.single-item', { dots: false, arrows: true, autoplay: true, autoplaySpeed: 5000 }],
        ['.main-slider', {
            slidesToShow: 5,
            centerMode: true,
            autoplay: true,
            responsive: [
                { breakpoint: 1200, settings: { slidesToShow: 3 } },
                { breakpoint: 720, settings: { arrows: false, centerMode: false, slidesToShow: 1 } },
            ],
        }],
        ['.main-video', {
            slidesToShow: 3,
            autoplay: true,
            responsive: [
                { breakpoint: 900, settings: { slidesToShow: 2 } },
                { breakpoint: 650, settings: { arrows: false, slidesToShow: 1 } },
            ],
        }],
    ];

    sliders.forEach(([selector, options]) => {
        $(selector).each(function () {
            if (!$(this).hasClass('slick-initialized')) {
                $(this).slick(options);
            }
        });
    });

    if ($('.slider-view').length && $('.slider-carousel').length) {
        $('.slider-view:not(.slick-initialized)').slick({
            slidesToShow: 1,
            arrows: false,
            fade: true,
            asNavFor: '.slider-carousel',
        });
        $('.slider-carousel:not(.slick-initialized)').slick({
            slidesToShow: 3,
            asNavFor: '.slider-view',
            focusOnSelect: true,
            responsive: [{ breakpoint: 570, settings: { slidesToShow: 3, arrows: false } }],
        });
    }
};

document.querySelectorAll('img[data-fallback-hide]').forEach((image) => {
    const hideUnavailableImage = () => image.classList.add('is-unavailable');

    if (image.complete && image.naturalWidth === 0) {
        hideUnavailableImage();
    } else {
        image.addEventListener('error', hideUnavailableImage, { once: true });
    }
});

document.querySelectorAll('form[data-ajax-form]').forEach((form) => {
    const submitButton = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-form-status]');

    form.addEventListener('submit', async (event) => {
        event.preventDefault();

        form.querySelectorAll('[data-error-for]').forEach((element) => {
            element.textContent = '';
        });

        if (status) {
            status.textContent = '';
            status.removeAttribute('data-state');
        }

        submitButton?.setAttribute('disabled', '');

        try {
            const response = await fetch(form.action, {
                method: form.method || 'POST',
                body: new FormData(form),
                headers: {
                    Accept: 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });
            const payload = await response.json().catch(() => ({}));

            if (!response.ok) {
                Object.entries(payload.errors || {}).forEach(([field, messages]) => {
                    const error = form.querySelector(`[data-error-for="${CSS.escape(field)}"]`);

                    if (error) {
                        error.textContent = Array.isArray(messages) ? messages[0] : String(messages);
                    }
                });

                throw new Error(payload.message || 'The request could not be submitted.');
            }

            form.reset();
            window.grecaptcha?.reset();

            if (status) {
                status.textContent = payload.success || 'Thank you. Your request has been sent.';
                status.dataset.state = 'success';
            }
        } catch (error) {
            if (status) {
                status.textContent = error instanceof Error
                    ? error.message
                    : 'The request could not be submitted.';
                status.dataset.state = 'error';
            }
        } finally {
            submitButton?.removeAttribute('disabled');
        }
    });
});

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeLegacyWidgets);
} else {
    initializeLegacyWidgets();
}
